/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

/**
  *
  * @param {Object} errorData
  */
const getAllExtraData = (errorData) => {
  let errorDataKeys = [];
  if (errorData !== null && typeof errorData === 'object') {
    errorDataKeys = Object.keys(errorData);
  }
  const extraData = {};
  if (errorData.stack) {
    extraData.stackInfo = errorData.stack;
  }
  if (errorData.config && errorData.config.timeTakenInMs) {
    extraData.timeoutlag = errorData.config.timeTakenInMs - errorData.config.timeout;
  }
  errorDataKeys.forEach((key) => {
    if (key === 'response') {
      // For HTTP Request
      if (errorData.response && errorData.response.status && errorData.response.config) {
        extraData['ErrorProperty:custom_http'] = `Error: HTTP Request failed with status code ${errorData.response.status} : ${errorData.response.config.url}`;
      }
    }
    extraData[`ErrorProperty:${key}`] = JSON.stringify(errorData[key]);
  });
  return extraData;
};

export default getAllExtraData;
